import { render } from "./BaseSidebarViewer.vue?vue&type=template&id=7f7c7462&scoped=true"
import script from "./BaseSidebarViewer.vue?vue&type=script&lang=js"
export * from "./BaseSidebarViewer.vue?vue&type=script&lang=js"

import "./BaseSidebarViewer.vue?vue&type=style&index=0&id=7f7c7462&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f7c7462"]])

export default __exports__